import { Icon } from "../../../components";
import { com } from "../../../proto/game.pb";
import { useModal } from "../../contexts";
import {
  BetAvatar,
  Image,
  TableCell,
  TableRow,
  Typography,
  WinAmount,
} from "../../ui";
import { formatDate } from "../../utils/formatDate";
import css from "./LeaderboardEntry.module.scss";

type Entry = com.achlid.crash.game.stateless.ILeaderboardEntry;

function fmt(n?: number | null, digits = 2) {
  return typeof n === "number" && isFinite(n) ? n.toFixed(digits) : "-";
}

export const LeaderboardEntry = ({ entry }: { entry: Entry }) => {
  const playerName = entry.playerName ?? `User ${entry.userId}`;
  const avatar = `${entry.avatar || "Avatar_1"}.png`;
  const { openModal } = useModal();
  return (
    <TableRow className={css.row}>
      <TableCell className={css.cell}>
        <BetAvatar
          className={css.avatar}
          avatar={avatar}
          username={playerName}
        />
      </TableCell>
      <TableCell className={css.cell}>
        <Typography variant="caption2" className={css.bet} color="light-grey">
          {fmt(entry.bestMultiplier)}
        </Typography>
      </TableCell>
      <TableCell className={css.cell}>
        <div className={css.roundX}>
          <div className={css.dateTime}>
            <Icon name="calendar" width={20} height={20} color="#545454" />
            <Typography variant="caption2" color="grey-black">
              {formatDate(entry.bestWinTimestamp, "date")}
            </Typography>
          </div>
          <Typography
            variant="caption2"
            className={css.multiplier}
            color="light-grey"
          >
            {fmt(entry.roundCrashPoint)}x
          </Typography>
        </div>
      </TableCell>
      <TableCell className={css.cell}>
        <Typography
          variant="caption2"
          className={css.multiplier}
          color="light-grey"
        >
          {fmt(entry.bestBetAmount)}
        </Typography>
      </TableCell>
      <TableCell className={css.cell}>
        <div className={css.winAmountContainer}>
          <button onClick={() => openModal("myBetDetails", entry.bestRoundId)}>
            <Image src="shield.png" variant="base" />
          </button>
          <WinAmount amount={entry.biggestWinAmount ?? 0} />
        </div>
      </TableCell>
    </TableRow>
  );
};
